import DeclineOnlineMeeting from './DeclineOnlineMeeting'

export default DeclineOnlineMeeting
